import type { MessagingGetChatRoomById200BasicInfoAllOf } from './messagingGetChatRoomById200BasicInfoAllOf';
import type { MessagingGetChatRoomById200BasicInfoAllOfTwo } from './messagingGetChatRoomById200BasicInfoAllOfTwo';

export type MessagingGetChatRoomById200BasicInfo = MessagingGetChatRoomById200BasicInfoAllOf & MessagingGetChatRoomById200BasicInfoAllOfTwo;
